// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

  .root{
    margin-top: 130px;
    padding-left: 20px;
    padding-right: 20px;
}

.create-compliance-container {
  width: 100%;
  margin: 0;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
}

.create-compliance-form {
  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #1f7c50;
  
  margin-bottom: 15px;
 
}

.form-section2 {
  padding: 20px;
  border: none;
  background-color: #fff;
 
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border: 1px solid #1f7c50 !important;
  outline: none;
}



.form-group textarea {
  resize: vertical;
}

.reference-control {
 
  align-items: center;
  gap: 10px;
  padding: 15px;
  background-color: #fff;
  border-radius: 10px;
  
  margin-top: 10px;
}

.point-control {
 
  align-items: center;
  gap: 10px;
  padding: 15px;
  background-color: #f7f7f7;
  margin-top: 10px;
  flex-direction: row;
  border:none
}

.submit-button{
  padding: 12px 25px;
  border: none;
  background-color: #1f7c50;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
}

.submit-button:hover {
  background-color: #196b43;
}

.add-reference-button,
.add-point-button {

  border: none;
  background-color:#1ab394 ;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-left: 10px;
  margin-bottom: 5px;
}


.add-reference-button{
  background-color: #f3c363 !important;
  color: #333;
}

.add-reference-button:hover{
  background-color: #e4b85f !important;
  color: #333;  

}




.add-point-button:hover {
  background-color: #15947b ;

}

.btn-gray {
  padding: 12px 25px;
  border: none;
  background-color: #6c757d;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-gray:hover {
  background-color: #5a6268;
}

.control-section {
  width: 60%;
  margin-left: 20px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content-compliance {
  background: white;
  padding: 20px;
 
  border-radius: 8px;
  text-align: center;
}
.btn-link {
  background: none;
  border: none;
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
  .create-button{
    background-color: #1f7c50;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 5px 20px;
    font-size: 16px;
    cursor: pointer;
    height: 35px;
  }

  .create-button:hover {
    background-color: #196b43;
    color: white;
  }


  .submit-button4 {
    border: none;
    background-color: #1f7c50;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    height: 40px !important;
    padding: 8px 24px;
    font-weight: 600;
    display: block;
    margin: 20px auto;
  }
  
  .submit-button4:hover {
    outline: none;
    background-color: #196b43;
  }

  .action-button-danger-without-border{
    padding: 2px 3px;
    margin-right: 5px; 
    background-color: transparent;
    color: rgb(236, 26, 26);
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }



  .action-button-success{
    padding: 3px 4px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: #8bc34a;
    border: 1px solid #8bc34a;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-danger {
    padding: 3px 4px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: rgb(236, 26, 26);
    border: 1px solid rgb(236, 26, 26);
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-danger-without-border{
    padding: 2px 3px;
    margin-right: 5px; 
    background-color: transparent;
    color: rgb(236, 26, 26);
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  

 

  .action-button-danger-without-border:hover{
    background-color: rgba(150, 214, 241, 0.87);
  }

  .action-button-success:hover{
    background-color: #8bc34a;
    color: white;
  }
  
  .action-button-danger:hover {
    background-color: rgb(236, 26, 26);
    color: white;
  }


  .action-button-info{
    padding: 3px 4px;
    margin-right: 5px;
    border: none;
    background-color: transparent;
    color: #31aec6;
    border: 1px solid #31aec6;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }

  .action-button-info:hover {
    background-color: #31aec6;
    color: white;
  }

`, "",{"version":3,"sources":["webpack://./src/pages/SurveyQuestion/BankQuestions/question.css"],"names":[],"mappings":";;EAEE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;;EAEd,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;;AAExB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;;EAGE,oCAAoC;EACpC,aAAa;AACf;;;;AAIA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EAGzB,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;;AAEb;;;;;AAKA;EACE,0BAA0B;;AAE5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;;EAEb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,0BAA0B;AAC5B;EACE;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;;EAGA;IACE,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IAEjB,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;;;EAIA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IAEjB,6BAA6B;IAC7B,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;;;;;EAMA;IACE,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,kCAAkC;IAClC,YAAY;EACd;;;EAGA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd","sourcesContent":["\r\n\r\n  .root{\r\n    margin-top: 130px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n}\r\n\r\n.create-compliance-container {\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 10px;\r\n  background-color: #ffffff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.create-compliance-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.section-title {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  color: #1f7c50;\r\n  \r\n  margin-bottom: 15px;\r\n \r\n}\r\n\r\n.form-section2 {\r\n  padding: 20px;\r\n  border: none;\r\n  background-color: #fff;\r\n \r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n  margin-bottom: 8px;\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus,\r\n.form-group textarea:focus {\r\n  border: 1px solid #1f7c50 !important;\r\n  outline: none;\r\n}\r\n\r\n\r\n\r\n.form-group textarea {\r\n  resize: vertical;\r\n}\r\n\r\n.reference-control {\r\n \r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 15px;\r\n  background-color: #fff;\r\n  border-radius: 10px;\r\n  \r\n  margin-top: 10px;\r\n}\r\n\r\n.point-control {\r\n \r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 15px;\r\n  background-color: #f7f7f7;\r\n \r\n  border:none;\r\n  margin-top: 10px;\r\n  flex-direction: row;\r\n  border:none\r\n}\r\n\r\n.submit-button{\r\n  padding: 12px 25px;\r\n  border: none;\r\n  background-color: #1f7c50;\r\n  color: white;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  outline: none;\r\n}\r\n\r\n.submit-button:hover {\r\n  background-color: #196b43;\r\n}\r\n\r\n.add-reference-button,\r\n.add-point-button {\r\n\r\n  border: none;\r\n  background-color:#1ab394 ;\r\n  color: white;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  margin-left: 10px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n\r\n.add-reference-button{\r\n  background-color: #f3c363 !important;\r\n  color: #333;\r\n}\r\n\r\n.add-reference-button:hover{\r\n  background-color: #e4b85f !important;\r\n  color: #333;  \r\n\r\n}\r\n\r\n\r\n\r\n\r\n.add-point-button:hover {\r\n  background-color: #15947b ;\r\n\r\n}\r\n\r\n.btn-gray {\r\n  padding: 12px 25px;\r\n  border: none;\r\n  background-color: #6c757d;\r\n  color: white;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.btn-gray:hover {\r\n  background-color: #5a6268;\r\n}\r\n\r\n.control-section {\r\n  width: 60%;\r\n  margin-left: 20px;\r\n}\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.modal-content-compliance {\r\n  background: white;\r\n  padding: 20px;\r\n \r\n  border-radius: 8px;\r\n  text-align: center;\r\n}\r\n.btn-link {\r\n  background: none;\r\n  border: none;\r\n  color: blue;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}\r\n  .create-button{\r\n    background-color: #1f7c50;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 5px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    height: 35px;\r\n  }\r\n\r\n  .create-button:hover {\r\n    background-color: #196b43;\r\n    color: white;\r\n  }\r\n\r\n\r\n  .submit-button4 {\r\n    border: none;\r\n    background-color: #1f7c50;\r\n    color: white;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    outline: none;\r\n    height: 40px !important;\r\n    padding: 8px 24px;\r\n    font-weight: 600;\r\n    display: block;\r\n    margin: 20px auto;\r\n  }\r\n  \r\n  .submit-button4:hover {\r\n    outline: none;\r\n    background-color: #196b43;\r\n  }\r\n\r\n  .action-button-danger-without-border{\r\n    padding: 2px 3px;\r\n    margin-right: 5px;\r\n    border: none; \r\n    background-color: transparent;\r\n    color: rgb(236, 26, 26);\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n\r\n\r\n  .action-button-success{\r\n    padding: 3px 4px;\r\n    margin-right: 5px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: #8bc34a;\r\n    border: 1px solid #8bc34a;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .action-button-danger {\r\n    padding: 3px 4px;\r\n    margin-right: 5px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: rgb(236, 26, 26);\r\n    border: 1px solid rgb(236, 26, 26);\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .action-button-danger-without-border{\r\n    padding: 2px 3px;\r\n    margin-right: 5px;\r\n    border: none; \r\n    background-color: transparent;\r\n    color: rgb(236, 26, 26);\r\n    border: none;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  \r\n\r\n \r\n\r\n  .action-button-danger-without-border:hover{\r\n    background-color: rgba(150, 214, 241, 0.87);\r\n  }\r\n\r\n  .action-button-success:hover{\r\n    background-color: #8bc34a;\r\n    color: white;\r\n  }\r\n  \r\n  .action-button-danger:hover {\r\n    background-color: rgb(236, 26, 26);\r\n    color: white;\r\n  }\r\n\r\n\r\n  .action-button-info{\r\n    padding: 3px 4px;\r\n    margin-right: 5px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: #31aec6;\r\n    border: 1px solid #31aec6;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .action-button-info:hover {\r\n    background-color: #31aec6;\r\n    color: white;\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
